var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('v-btn',{attrs:{"download":"Mentions légales Tsukigo","href":_vm.pdfLink,"width":"fit-content","text":""}},[_vm._v("Mentions légales")]),_vm._v(" 2022 — Développé par Sarah Brisson ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }